<div class="{{ data.isRefresh && data.actionLabel ? 'my-outer-snackbar-container' : 'my-snackbar-container' }}">
  <div class="my-snackbar-container">
    <mat-icon class="material-symbols-outlined my-snackbar-icon">
      {{ data.icon }}
    </mat-icon>
    <span class="my-snackbar-message">{{ data.message }}</span>
  </div>

  @if (data.isRefresh && data.actionLabel) {
    <button class="my-snackbar-btn" type="button" (click)="snackbarRef.dismissWithAction()">
      {{ data.actionLabel }}
    </button>
  }
</div>
